import { bootstrapApplication } from '@angular/platform-browser';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { licenseKey } from './devextreme-license';
import config from 'devextreme/core/config';

if (environment.production) {
  enableProdMode();
}

config({ licenseKey });

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
